import { Injectable } from '@angular/core';

import { AggregationRequest } from '../common-interfaces-classes/AggregationRequest';
import { TIAggRequest } from '../common-interfaces-classes/TIAggRequest';

@Injectable({
  providedIn: 'root'
})
export class AggReqObjectHandlerService {

  constructor() { }

  sharedRequestObject: AggregationRequest = new TIAggRequest();

  setShareRequestObject(data) {
    this.sharedRequestObject = Object.assign({}, data);
  }

  setStartIndex(idx: number) {
    this.sharedRequestObject.startindex = idx;
  }

  getSharedRequestObject() {
    return Object.assign({}, this.sharedRequestObject);
  }
}
